import { Controller } from "@hotwired/stimulus"
import ClipboardJS from "clipboard"
import tippy from "tippy.js";

export default class extends Controller {
  static values = {
    successMessage: String,
    errorMessage: String
  }

  connect() {
    this.clipboard = new ClipboardJS(this.element, {
      text: function(trigger) {
        // Prefer explicit text if provided
        if (trigger.getAttribute("data-text")) return trigger.getAttribute("data-text");

        const sourceSelector = trigger.getAttribute("data-source");
        if (!sourceSelector) return "";

        const el = document.querySelector(sourceSelector);
        if (!el) return "";

        // If source is a line-numbered container, copy only content without numbers
        if (el.dataset && el.dataset.cleanCopy === 'line-numbers') {
          const lines = Array.from(el.querySelectorAll('.line-content'));
          return lines.map(l => l.textContent).join('\n');
        }

        // Default behavior: copy visible text
        return el.innerText;
      }
    })
    this.clipboard.on("success", (e) => this.tooltip(this.successMessage))
    this.clipboard.on("error",   (e) => this.tooltip(this.errorMessage))
  }

  tooltip(message) {
    tippy(this.element, {
      theme: "light",
      content: message,
      showOnCreate: true,
      onHidden: (instance) => {
        instance.destroy()
      }
    })
  }

  get successMessage() {
    return this.successMessageValue || "Copied!"
  }

  get errorMessage() {
    return this.errorMessageValue || "Failed!"
  }
}
